import styled from 'styled-components';

export const PlaceholderCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 238px;
  padding: 10px 15px 15px 15px;
`;

export const PlaceholderCardHeader = styled.div`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
`;

export const PlaceholderCardDate = styled.div`
  width: calc(100% - 40px);
  padding-left: 8px;
  overflow: hidden;
  white-space:nowrap;
  text-overflow: ellipsis;
  color: ${(props) => props.theme['color.text.light']};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
`;

export const PlaceholderCardContent = styled.div`
  display: flex;
  font-size: 20px;
  height: 100%;
  color: ${(props) => props.theme['color.text.title']};
  justify-content: center;
  align-items: center;
`;

export const PlaceholderCardTitle = styled.div`
  line-height: 34px;
  display: block;
  padding: 0 20%;
  width: 100%;
`;
